import Notification from './Notification';
export default Notification;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-notification/es/index.js
// module id = 440
// module chunks = 0